<template>
  <div v-if="error" class="tle-card">
    <div class="tle-head" @click="toggle">
      <span class="tle-badge">{{ error.error_kind || 'error' }}</span>
      <span class="tle-kind">{{ error.kind || EMPTY_VALUE }}</span>
      <span class="tle-muted">{{ error.flow }} · {{ error.direction }}</span>
      <span class="tle-date">{{ formatDate(error.created_dt) }}</span>
      <span v-if="error.attempt_no" class="tle-muted">#{{ error.attempt_no }}</span>
      <span class="tle-chevron">{{ expanded ? '▲' : '▼' }}</span>
    </div>

    <div v-if="error.error_detail" class="tle-detail">{{ error.error_detail }}</div>

    <div v-show="expanded" class="tle-extra">
      <div class="tle-grid">
        <div v-if="error.cargo_trip_id" class="tle-row">
          <span class="tle-lbl">Рейс (ID)</span>
          <span class="tle-val">{{ error.cargo_trip_id }}</span>
        </div>
        <div v-if="error.cargo_trip_trip_id || error.trip_id" class="tle-row">
          <span class="tle-lbl">Рейс</span>
          <span class="tle-val">{{ error.cargo_trip_trip_id || error.trip_id }}</span>
        </div>
        <div v-if="error.tms_id" class="tle-row">
          <span class="tle-lbl">TMS ID</span>
          <span class="tle-val">{{ error.tms_id }}</span>
        </div>
        <div v-if="error.actor" class="tle-row">
          <span class="tle-lbl">Актор</span>
          <span class="tle-val">{{ error.actor }}</span>
        </div>
        <div v-if="error.source_service" class="tle-row">
          <span class="tle-lbl">Источник</span>
          <span class="tle-val">{{ error.source_service }}</span>
        </div>
        <div v-if="error.driver_name" class="tle-row">
          <span class="tle-lbl">Водитель</span>
          <span class="tle-val">{{ error.driver_name }}</span>
        </div>
        <div v-if="error.car_number" class="tle-row">
          <span class="tle-lbl">Машина</span>
          <span class="tle-val">{{ error.car_number }}</span>
        </div>
      </div>

      <div v-if="error.tms_message" class="tle-msg">
        <div class="tle-msg-title">Ответ TMS</div>
        <pre class="tle-pre">{{ error.tms_message }}</pre>
      </div>
    </div>

    <router-link v-if="logLink" :to="logLink" class="tle-link">Журнал TMS →</router-link>
  </div>
</template>

<script>
import { ref } from 'vue';
import { formatDate, EMPTY_VALUE } from '@/pages/pureBidding/helpers';

export default {
  name: 'TmsLastErrorCard',
  props: {
    error: { type: Object, default: null },
    logLink: { type: String, default: '' },
  },
  setup() {
    const expanded = ref(false);
    const toggle = () => {
      expanded.value = !expanded.value;
    };
    return { EMPTY_VALUE, expanded, toggle, formatDate };
  },
};
</script>

<style scoped>
.tle-card {
  border: 1px solid #f5c2c7;
  border-left: 3px solid #dc3545;
  border-radius: 4px;
  background: #fff;
  padding: 8px 10px;
  font-size: 12px;
}

.tle-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  cursor: pointer;
  user-select: none;
}

.tle-badge {
  background: #fdeaea;
  color: #c0392b;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  padding: 1px 8px;
}

.tle-kind { font-weight: 700; color: #333; }
.tle-muted { color: #98a2b3; font-size: 11px; }
.tle-date { color: #667085; margin-left: auto; }
.tle-chevron { color: #98a2b3; font-size: 10px; }

.tle-detail {
  margin-top: 6px;
  color: #842029;
  word-break: break-word;
  white-space: pre-wrap;
}

.tle-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 4px 16px;
  margin-top: 8px;
}
.tle-row { display: flex; gap: 6px; }
.tle-lbl { color: #98a2b3; min-width: 70px; }
.tle-val { color: #333; word-break: break-word; }

.tle-msg { margin-top: 8px; }
.tle-msg-title { color: #98a2b3; font-size: 11px; margin-bottom: 2px; }
.tle-pre {
  background: #f8f9fa;
  border: 1px solid #e6eaf0;
  border-radius: 4px;
  color: #4b5563;
  font-family: inherit;
  font-size: 11px;
  margin: 0;
  max-height: 260px;
  overflow: auto;
  padding: 8px;
  white-space: pre-wrap;
  word-break: break-word;
}

.tle-link {
  color: #007bff;
  display: inline-block;
  font-size: 12px;
  margin-top: 8px;
  text-decoration: none;
}
.tle-link:hover { text-decoration: underline; }
</style>
